import styled from 'styled-components';
import { componentsThemeMap, colorToVariable } from '../../componentsThemeMap.js';
import { SectionComponentLayout } from '../../layout/SectionComponentLayout.js';
import { TwoColumnLayout } from '../../layout/TwoColumnLayout.js';
import { CTAButtons } from '../../ui/CTAButtons.js';
import '../../ui/Div/index.js';
import { createListRichTextOptions } from '../../ui/RichText/options/listRichTextOptions.js';
import { RichText } from '../../ui/RichText/RichText.js';
import { Text } from '../../ui/Text.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
function HighlightTextImageContent({
  alignContent,
  eyebrow,
  headline,
  subhead,
  list,
  listStyle,
  ctaButtonLabel,
  ctaButtonUrl,
  secondaryButtonLabel,
  secondaryButtonUrl,
  legalText,
  logoList,
  style
}) {
  const isTwoColumns = alignContent === 'two-columns';
  const _componentsThemeMap$s = componentsThemeMap[style],
    foreground = _componentsThemeMap$s.foreground,
    foregroundSecondary = _componentsThemeMap$s.foregroundSecondary,
    background = _componentsThemeMap$s.background,
    foregroundInlineLink = _componentsThemeMap$s.foregroundInlineLink;
  const hasLogoSpacing = eyebrow || headline || subhead || list || ctaButtonLabel || secondaryButtonLabel;
  return /*#__PURE__*/jsx(SectionComponentLayout, {
    hasSpacingHorizontal: true,
    hasSpacingVertical: true,
    flexDirection: "row",
    height: "100%",
    background: "transparent",
    children: /*#__PURE__*/jsx(Div, {
      alignItems: "center",
      children: /*#__PURE__*/jsx(TwoColumnLayout, {
        mainContentPosition: isTwoColumns ? 'left' : 'top',
        wrapOnTablet: true,
        mainContent: /*#__PURE__*/jsxs(Div, {
          flexDirection: "column",
          children: [eyebrow && /*#__PURE__*/jsx(Text, {
            variant: "label1",
            as: "p",
            color: foregroundSecondary,
            children: eyebrow
          }), /*#__PURE__*/jsx(Text, {
            variant: {
              sm: 'title2',
              lg: 'display2'
            },
            as: "h2",
            color: foreground,
            spacingEnd: isTwoColumns ? {
              sm: 0,
              lg: 2
            } : 0,
            children: headline
          })]
        }),
        secondaryContent: /*#__PURE__*/jsxs(Div, {
          flexDirection: "column",
          gap: 3,
          children: [subhead && /*#__PURE__*/jsx(Text, {
            variant: "body",
            color: foregroundSecondary,
            as: "p",
            spacingTop: isTwoColumns ? {
              sm: 2,
              lg: 0
            } : 2,
            children: /*#__PURE__*/jsx(BreakSpaces, {
              children: subhead
            })
          }), list && /*#__PURE__*/jsx(Div, {
            css: {
              display: 'contents',
              p: {
                color: colorToVariable(foregroundSecondary)
              }
            },
            children: /*#__PURE__*/jsx(RichText, {
              content: list,
              richTextOptions: createListRichTextOptions(listStyle),
              color: foregroundSecondary,
              secondaryColor: foregroundSecondary,
              foregroundInlineLink: foregroundInlineLink
            })
          }), (ctaButtonLabel || secondaryButtonLabel) && /*#__PURE__*/jsx(CTAButtons, {
            ctaButtonLabel: ctaButtonLabel,
            ctaButtonUrl: ctaButtonUrl,
            secondaryButtonLabel: secondaryButtonLabel,
            secondaryButtonUrl: secondaryButtonUrl,
            contentBackground: background
          }), logoList && /*#__PURE__*/jsx(Div, {
            width: "100%",
            spacingTop: {
              sm: hasLogoSpacing ? 3 : 0,
              md: hasLogoSpacing ? 7 : 0
            },
            spacingBottom: {
              sm: hasLogoSpacing ? 3 : 0,
              md: 0
            },
            flexDirection: "column",
            alignItems: {
              sm: 'center',
              md: 'flex-start'
            },
            children: /*#__PURE__*/jsx(Div, {
              display: "grid",
              gap: 3,
              gridTemplateColumns: {
                sm: 'repeat(1, 1fr)',
                md: 'repeat(2, 1fr)'
              },
              children: logoList
            })
          }), legalText && /*#__PURE__*/jsx(Text, {
            variant: "legal",
            as: "p",
            color: foregroundSecondary,
            spacingTop: {
              sm: 3,
              lg: 5
            },
            children: legalText
          })]
        })
      })
    })
  });
}
const BreakSpaces = styled.span`
  white-space: break-spaces;
`;
export { HighlightTextImageContent };
//# sourceMappingURL=HighlightImageTextContent.js.map
